import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UtilitiesService } from '../../../services/utilities/utilities.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-add-new-credit-card-action',
  templateUrl: './add-new-credit-card-action.component.html',
  styleUrls: ['./add-new-credit-card-action.component.scss']
})
export class AddNewCreditCardActionComponent implements OnInit, OnDestroy {
  cleaner$ = new Subject<void>();
  isMobileView: boolean = false;
  constructor(private utilService: UtilitiesService) {}
  ngOnInit(): void {
    this.utilService.screenWidth$.pipe(takeUntil(this.cleaner$)).subscribe(width => {
      this.isMobileView = width < 576;
    });
  }
  
  @Input() addOrEditCard: () => void = () => {};
  @Input() label: string = 'Credit card';

  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
  }
}
